module.exports = __webpack_public_path__ + "static/media/extractive_services_law_blue.b708ba17.svg";